import React, { Fragment } from "react";
import Loader from "./Loader";

const FeeLoader = () => (
  <Fragment>
    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6">
      {/* card for fees */}
      <div className="card min-h-280">
        <div className="card-body">
          <div className="dashboard-transaction-container">
            <div className="details">
              <div className="big-amount-text">
                <Loader width="350" height="30" />
              </div>
              <div className="fee-description">
                <Loader width="350" height="15" />
              </div>
            </div>
            <div className="button-action-container">
              <div className="row no-gutters">
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                  <Loader width="350" height="30" />
                </div>
                <div className="days-remaining col-xs-12 col-sm-12 col-md-6 col-lg-6">
                  <Loader width="350" height="15" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* card for fees */}
    </div>
  </Fragment>
);

const FeesLoader = () => (
  <Fragment>
    <FeeLoader />
    <FeeLoader />
  </Fragment>
);

export default FeesLoader;
